import { render, staticRenderFns } from "./ExpenseCategoryList.vue?vue&type=template&id=4e14a87a&scoped=true&"
import script from "./ExpenseCategoryList.vue?vue&type=script&lang=ts&"
export * from "./ExpenseCategoryList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e14a87a",
  null
  
)

export default component.exports